import { useAppSelector } from 'app/hooks';
import { existingEquipmentPageVisible } from 'utils/existing-equipment-page-visibility';

export default function useExistingEquipmentPageVisible() {
  const projectSettings = useAppSelector(
    (state) => state.project.projectSettings
  );
  const systemPreference = projectSettings.find(
    (ps) => ps.code === 'system_preference'
  )?.value;
  const projectType = projectSettings.find(
    (ps) => ps.code === 'project_type'
  )?.value;
  return existingEquipmentPageVisible(systemPreference, projectType);
}
